import { type SetState } from '@/store/store';
import { type ThemeVariant, DEFAULT_THEME_VARIANT } from '@/theme/config/constants';

export type ThemeSliceProps = {
    theme: {
        variant: ThemeVariant;
        isSystemTheme: boolean;
        setVariant: (variant: ThemeVariant) => void;
        setIsSystemTheme: (enabled: boolean) => void;
    };
};

export const theme = ({ set }: SetState<ThemeSliceProps>): ThemeSliceProps => ({
    theme: {
        variant: DEFAULT_THEME_VARIANT,
        setVariant: (variant) =>
            set((state) => ({
                theme: {
                    ...state.theme,
                    variant
                }
            })),
        isSystemTheme: false,
        setIsSystemTheme: (enabled) =>
            set((state) => ({
                theme: {
                    ...state.theme,
                    isSystemTheme: enabled
                }
            }))
    }
});
